import React from 'react'
import { useRouter } from 'next/router'
import { LinkButton } from '@/atoms/Button'
import { ParagraphMD, TitleMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

export interface Props {
  title: string
  caption?: string
  className?: string
}

const MediaGalleryItemDetails: React.FC<Props> = ({ title, caption, className }) => {
  const { t } = useTranslate('torches')
  const expressInterest = t('expressInterest', 'Express Interest')
  const { query } = useRouter()

  return (
    <div className={className}>
      <div className="max-w-xl">
        <TitleMD as={(p) => <h3 {...p} />}>{title}</TitleMD>
        {caption && <ParagraphMD className="mt-2">{caption}</ParagraphMD>}
        <LinkButton
          href={`/torches/${query.torch}/express-interest`}
          variant="oxide-bright"
          className="mt-4 inline-block"
          tabIndex={-1}
        >
          {expressInterest}
        </LinkButton>
      </div>
    </div>
  )
}

export default MediaGalleryItemDetails
